import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { POC_TYPE, POC_SITE_TYPE, POC_SUB_SITE_TYPE, ALL_CLIENT, CLIENT_BUSINESS, BUSINESS_DETAILS } from "./type";

export const pocType = () => async (dispatch) => {
  const res = await callWebService(callTypes.get, "", Config.pocDetials.type);
  if (res) {
    const { data } = res;
    dispatch({ type: POC_TYPE, payload: data.response.data });
    return true;
  }
};

export const pocSiteType = () => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.pocDetials.siteType}1`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: POC_SITE_TYPE, payload: data.response.data });
    return true;
  }
};

export const pocSubSiteType = (parent_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.pocDetials.siteType}1&parent_id=${parent_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: POC_SUB_SITE_TYPE, payload: data.response.data });
    return true;
  }
};

export const addClient = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.pocDetials.addClient
  );
  if (res?.data?.response?.status) {
    return true
  }
  return false;
}

export const getAllClients = (lead_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.pocDetials.getAllClients}?lead_id=${lead_id}`
  );
  
  if (res) {
    const { data } = res;
    dispatch({ type: ALL_CLIENT, payload: data.response.data });
    return true;
  }
}

export const getAddressClient = (client_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.pocDetials.getAddressClient}?client_id=${client_id}`
  );
  if (res) {
    const { data } = res;
    return data.response?.data ?? data.data;
  }
}

export const setAddressClient = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.pocDetials.setAddressClient
  );
  if (res) {
    return res?.data
  }
  return false;
}

export const getClientBusinessDetails = (comm_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.pocDetials.getClientBusinessDetails}?comm_id=${comm_id}`
  );
  
  if (res) {
    const { data } = res;
    dispatch({ type: CLIENT_BUSINESS, payload: data.response.data });
    return true;
  }
}

export const getAddressBusiness = (lead_id, comm_id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.pocDetials.getAddressBusiness}?lead_id=${lead_id}&comm_id=${comm_id}`
  );
  if (res) {
    const { data } = res;
    const payload = data.response?.data ?? data.data;
    dispatch({ type: BUSINESS_DETAILS, payload: payload });
    return true;
  }
}

export const setAddressBusiness = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.pocDetials.setAddressBusiness
  );
  if (res) {
    return res.data
  }
  return false;
}
